import styled from 'styled-components';
export const BreadcrumbsWrapper = styled.div `
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  max-width: 100%;
  margin-bottom: ${props => props.noMargin ? '' : '1rem'};
  ${props => props.lastNotActive ? `
    & .breadcrumb-el:last-child {
    pointer-events: none;
  }` : ''}
`;
export const BreadcrumbElementWrapper = styled.div `
  cursor: pointer;
  ${props => !props.wrap && `white-space: nowrap;`}
  ${props => props.crop ? `
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 160px;
  ` : ''}
  &:hover {
    text-decoration: underline;
  }
  ${props => props.theme.mixins.mobile(`
    font-size: .8rem;
  `)}
`;
export const BreadcrumbSeparator = styled.div `
  margin: 0 .5rem;
`;
